module.exports = __webpack_public_path__ + "assets/img/ability4.c3709cbf.png";